/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import moment from 'moment';

import { ERROR_MESSAGE } from '../../const';
import { Input as InputComponent, YesNo as YesNoInput } from '../Field';

const today = moment().format('MM/DD/YYYY');
const LABEL_STYLES = { display: 'flex', gap: 5, marginBottom: 5 };
const DISCLOSURES_LABEL_STYLES = {
  display: 'grid',
  gridTemplateColumns: '1fr 4fr',
};

const Agreements = ({ data, ...props }) => {
  const Input = inputProps => (
    <InputComponent data={data} {...props} errorMessage={ERROR_MESSAGE.AGREEMENTS} {...inputProps} />
  );

  const [fraudCheck, setFraudCheck] = useState(data.fraudCheck?.value);
  const [terminatedCheck, setTerminatedCheck] = useState(data.terminatedCheck?.value);
  const [complaintCheck, setComplaintCheck] = useState(data.complaintCheck?.value);
  const [serviceAgreementDate, setServiceAgreementDate] = useState(data.serviceAgreementDate?.value);
  const [pricingAgreementDate, setPricingAgreementDate] = useState(data.pricingAgreementDate?.value);

  const setupCheck =
    fn =>
    ({ target: { checked } }) => {
      const value = checked ? today : '';
      fn(value);
    };

  return (
    <fieldset className="m-btm-41 w-800">
      <span className="fw-500 fs-12 d-inline-block m-btm-24">Before continuing, read and accept the terms below</span>

      <label className="fs-13 fw-500" style={LABEL_STYLES} htmlFor="serviceAgreementDate">
        <input type="checkbox" checked={!!serviceAgreementDate} onChange={setupCheck(setServiceAgreementDate)} />I have
        read and consent to{' '}
        <a
          href="https://www.bluesnap.com/ecommerce/merchant-agreements/"
          className="no-decoration"
          target="_blank"
          rel="noopener noreferrer"
        >
          Clientbook’s Merchant Agreement
        </a>
      </label>
      <Input label="Service agreement sign date" id="serviceAgreementDate" defaultValue={serviceAgreementDate} hidden />

      <label className="fs-13 fw-500" style={LABEL_STYLES} htmlFor="pricingAgreementDate">
        <input type="checkbox" checked={!!pricingAgreementDate} onChange={setupCheck(setPricingAgreementDate)} />I have
        read and consent to{' '}
        <a
          href="https://terms.clbk.app/ReferredMerchantSchUSD_JUN_2021.pdf"
          className="no-decoration"
          target="_blank"
          rel="noopener noreferrer"
        >
          Clientbook’s Pricing Agreement
        </a>
      </label>
      <Input label="Pricing agreement sign date" id="pricingAgreementDate" defaultValue={pricingAgreementDate} hidden />

      <h2 className="fs-16 fw-600 m-top-0 m-btm-8">Disclosures</h2>
      <span className="fw-500 fs-12 d-inline-block m-btm-24">
        Before continuing, please answer the following questions
      </span>

      <label className="fs-13 fw-500" style={DISCLOSURES_LABEL_STYLES}>
        <YesNoInput
          selectedValue={fraudCheck}
          handleChange={e => {
            setFraudCheck(e.target.value);
          }}
        />
        Has your company been placed in any Fraud Monitoring or Risk Monitoring Program?
      </label>
      <Input label="Service agreement sign date" id="businessRiskMonitoring" defaultValue={fraudCheck} hidden />

      <label className="fs-13 fw-500" style={DISCLOSURES_LABEL_STYLES}>
        <YesNoInput
          type="checkbox"
          selectedValue={terminatedCheck}
          handleChange={e => {
            setTerminatedCheck(e.target.value);
          }}
        />
        Has your company been previously terminated by a payment processor, acquirer, financial institution, or operator
        of a payment system due to fraud, Credit Card Laundering, or excessively high chargeback rates?
      </label>
      <Input label="Service agreement sign date" id="businessRiskPayment" defaultValue={terminatedCheck} hidden />

      <label className="fs-13 fw-500" style={DISCLOSURES_LABEL_STYLES}>
        <YesNoInput
          type="checkbox"
          selectedValue={complaintCheck}
          handleChange={e => setComplaintCheck(e.target.value)}
        />
        Has your company been the subject of a complaint filed by or Assurance of Voluntary Compliance obtained by the
        Federal Trade Commission?
      </label>
      <Input label="Service agreement sign date" id="businessRiskByCommission" defaultValue={complaintCheck} hidden />
    </fieldset>
  );
};

export default Agreements;
